import { Fragment } from "react";
import { Col, Row } from "@crehana/ui";
import { LastActivityCourseCardSkeleton } from "../../../../../components/Cards/LastActivityCourseCard";
import { ProjectCardSkeleton } from "../../../components/ProjectCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TabletLayoutSkeleton = function TabletLayoutSkeleton(_ref) {
  var isDark = _ref.isDark,
    dataTestId = _ref['data-testid'];
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      "data-testid": dataTestId,
      className: "mb-24",
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx(LastActivityCourseCardSkeleton, {
          isDark: isDark
        })
      })
    }), /*#__PURE__*/_jsx(ProjectCardSkeleton, {
      isDark: isDark
    })]
  });
};
export default TabletLayoutSkeleton;